import React, { useState, useEffect } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { withRouter, RouteComponentProps, useParams } from 'react-router-dom';

import { useQuery } from '@apollo/client';

import Dashboard from '../../../../../layouts/Dashboard';
import ViewCategory from '../../../../../components/Global/Categories/View';

import { selectCategoryInitQuery, Category } from './queries';

import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

interface UrlParams {
  organisation_id: string;
  category_id: string;
}

const ViewCategoryAdmin = ({ classes, history }: Props): React.ReactElement => {
  const { organisation_id, category_id } = useParams<UrlParams>();

  const [category, setCategory] = useState<Category>({
    name: '',
    organisation: {
      name: '',
    },
  });

  const { data: categoryInitData } = useQuery(selectCategoryInitQuery(category_id), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && categoryInitData) {
      setCategory(categoryInitData.area_sections_by_pk);
    }
    return () => {
      mounted = false;
    };
  }, [categoryInitData]);

  const handleEdit = () => {
    history.push(`/admin/trusts/${organisation_id}/grouping/${category_id}/edit`);
  };

  return (
    <Dashboard
      breadcrumbs={[
        { label: 'Trusts', link: '/admin/trusts' },
        { label: category.organisation.name, link: `/admin/trusts/${organisation_id}` },
        { label: 'Grouping', link: `/admin/trusts/${organisation_id}/grouping` },
        { label: category.name },
      ]}>
      <ViewCategory category_id={category_id} handleEdit={handleEdit} />
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(ViewCategoryAdmin));
